var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1047 0.520417C17.1127 0.52284 17.1206 0.525258 17.1292 0.525946C18.0127 0.454394 18.7697 1.1428 18.7697 2.02101V15.5783C18.7697 16.2223 18.3599 16.7969 17.7491 17.0078L13.224 18.5165C13.0583 18.5677 12.9054 18.591 12.7442 18.591C11.9134 18.591 11.2378 17.9154 11.2378 17.0847V16.3315H8.9783C7.73253 16.3315 6.71875 15.3177 6.71875 14.0719V12.5656C6.71875 12.1498 7.05618 11.8124 7.47193 11.8124C7.88769 11.8124 8.22511 12.1498 8.22511 12.5656V14.0719C8.22511 14.4869 8.56329 14.8251 8.9783 14.8251H11.2378V3.52738C11.2378 2.88341 11.6476 2.30873 12.2577 2.09784L12.4874 2.02101H8.9783C8.56329 2.02101 8.22511 2.35919 8.22511 2.77419V3.52738C8.22511 3.94313 7.88769 4.28056 7.47193 4.28056C7.05618 4.28056 6.71875 3.94313 6.71875 3.52738V2.77419C6.71875 1.52843 7.73253 0.514648 8.9783 0.514648H17.075C17.0856 0.514648 17.0952 0.517536 17.1047 0.520417ZM5.74691 4.50123L8.75963 7.51396C9.05413 7.80845 9.05413 8.28446 8.75963 8.57896L5.74691 11.5917C5.5315 11.8071 5.20763 11.8719 4.92594 11.7551C4.645 11.6384 4.46122 11.3635 4.46122 11.0592V8.79964H1.44849C1.03274 8.79964 0.695312 8.46221 0.695312 8.04646C0.695312 7.6307 1.03274 7.29327 1.44849 7.29327H4.46122V5.03373C4.46122 4.72944 4.645 4.45453 4.92594 4.33779C5.20763 4.22104 5.5315 4.28582 5.74691 4.50123Z",
    fill: "#d9d9d9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4064_2393",
    x1: 119.373,
    y1: 111.481,
    x2: 60.3023,
    y2: 138.8,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A1617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55653,
    stopColor: "#5926F0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4828A0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogin);
export default __webpack_public_path__ + "static/media/login.0ce5473eef5efe051e7b7ac947ec1492.svg";
export { ForwardRef as ReactComponent };